/**
 * Defaults that Tiptap and ProseMirror apply internally but do not export.
 */

/**
 * Priority a Tiptap extension gets when it declares none (`@tiptap/core`'s module-local
 * `defaultPriority`). Orders extensions against each other — loading, plugin order, schema
 * key order.
 */
export const DEFAULT_EXTENSION_PRIORITY = 100;

/**
 * Priority a ProseMirror parse rule gets when it declares none (`DOMParser.schemaRules`).
 * Rules are sorted by it, and at equal priority every mark rule is inserted ahead of the
 * node rules.
 */
export const DEFAULT_PARSE_RULE_PRIORITY = 50;

export const LINK_EXTENSION_PRIORITY = 1000;
